import React from 'react';
import { Box, MenuItem, TextField, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ActionPanel } from "./ActionPanel";
import AutocompleteElementsField from "components/Form/AutocompleteElementsField";

export const types = [
  'drug',
  'ecrf',
  'element',
];

export interface Props {}

export const HeaderPanel = (props: Props) => {
    const { t } = useTranslation();
    const elements: any[] = [
      {
        render: (element: any, fn: any) => (
          <Tooltip title={t('type')} arrow>
            <TextField
              label={t('Type')}
              select
              fullWidth
              variant={'outlined'}
              // value={element?.type || ''}
              value={2}
              size={'small'}
              onChange={(event) => fn(event.target.value, 'type')}
              disabled={true}
            >
              {/** Display list of all numbers */}
              {types.map((type: string, index) => (
                <MenuItem key={type} value={String(index)}>
                  {type}
                </MenuItem>
              ))}
            </TextField>
          </Tooltip>
        ),
        key: 'type',
      },
      {
        render: (element: any, fn: any) => (
          <Tooltip title={t('name')} arrow>
            <TextField
              label={t('Name')}
              fullWidth
              variant={'outlined'}
              value={element?.name || ''}
              size={'small'}
              onChange={(event) => fn(event.target.value, 'name')}
            />
          </Tooltip>
        ),
        key: 'type',
      },
      {
        render: (element: any, fn: any) => (
          <Tooltip title={t('select-element')} arrow>
            <Box>
              <AutocompleteElementsField
                name={'elements'}
                label={t('Elements')}
                fullWidth
                size={'small'}
                onChange={(value) => fn(value, 'elements')}
              />
            </Box>
          </Tooltip>
        ),
        key: 'elements',
      },
    ];

    return <ActionPanel elements={elements} />;
};
